import{N as e}from"./chunk-SPDR3QGG.js";var r=n=>{switch(n){case"development":return{};case"regression":return{};case"staging":return{};case"production":return{}}},o=r(e.environmentId);export{o as a};
